export const JOINED = 'joined';
export const AWAITING = 'awaiting';
